(() => {
  const configNode=document.querySelector('[data-eg-used-collection-config]');
  if(!configNode)return;
  let config={openConditionFilter:true};
  try{config=Object.assign(config,JSON.parse(configNode.textContent||'{}'));}catch(_){ }
  document.documentElement.classList.add('eg-used-collection-page');
  const normalize=(value='')=>String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();

  const cleanupLegacy=()=>{
    document.querySelectorAll('.eg-used-card-signals,.eg-used-card-review-wrap').forEach((node)=>node.remove());
    document.querySelectorAll('.eg-used-card-review-mode').forEach((node)=>node.classList.remove('eg-used-card-review-mode'));
  };

  const enhanceConditionFilter=()=>{
    if(!config.openConditionFilter)return;
    const wrapper=document.querySelector('.egt-collection-catalog #FacetsWrapperDesktop');
    if(wrapper){
      const details=[...wrapper.querySelectorAll('.facets__disclosure-vertical')];
      const condition=details.find((detail)=>{const text=normalize(detail.querySelector(':scope > summary')?.textContent||'');return text.includes('condicion')||text.includes('estado')||text.includes('condition');});
      if(condition){condition.classList.add('eg-used-condition-filter');condition.open=true;const first=details[0];if(first&&first!==condition)wrapper.insertBefore(condition,first);}
    }
    document.querySelectorAll('.mobile-facets details').forEach((detail)=>{const text=normalize(detail.querySelector(':scope > summary')?.textContent||'');if(text.includes('condicion')||text.includes('estado')||text.includes('condition'))detail.classList.add('eg-used-condition-filter');});
  };

  let frame=0;
  const enhance=()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;cleanupLegacy();enhanceConditionFilter();});};
  enhance();
  const root=document.querySelector('collection-component');
  if(root){const observer=new MutationObserver((mutations)=>{if(mutations.some((m)=>m.addedNodes.length||m.removedNodes.length))enhance();});observer.observe(root,{childList:true,subtree:true});}
  document.addEventListener('shopify:section:load',enhance);
})();
